var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlettiMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01092 22.1487C4.84995 22.1487 1.16202 22.1473 0.00104332 22.1487L0.0318165 23.9894C5.76814 24.0034 18.9863 24.002 24.7227 23.9978L24.6891 22.1487H16.4498C17.0499 21.8269 17.4584 21.1933 17.4584 20.4659C17.4584 19.4127 16.6023 18.5566 15.549 18.5566C14.4958 18.5566 13.6397 19.4127 13.6397 20.4659C13.6397 21.1933 14.0482 21.8255 14.6482 22.1487H11.1807H7.81112C8.41119 21.8269 8.81963 21.1933 8.81963 20.4659C8.81963 19.4127 7.96359 18.5566 6.91032 18.5566C5.85706 18.5566 5.00101 19.4127 5.00101 20.4659C5.00101 21.1933 5.41085 21.8269 6.01092 22.1487Z",
    fill: "#21014C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5123 18.9952C17.9696 17.9056 16.8464 17.1558 15.5484 17.1558C13.8167 17.1558 12.3928 18.493 12.2529 20.1897C11.5675 20.2219 10.8835 20.2289 10.2079 20.2163C10.0806 18.507 8.65108 17.1558 6.90962 17.1558C5.40595 17.1558 4.13448 18.1643 3.73303 19.5393C2.1958 19.2624 0.931313 18.956 0.107443 18.7378C0.96768 15.4172 4.08832 5.18522 10.6975 1.32324C15.3204 -1.37497 21.2567 0.184647 23.9549 4.80615C26.6531 9.42766 25.0977 15.3598 20.4776 18.0608C19.8538 18.4259 19.1963 18.735 18.5123 18.9952ZM18.9068 7.75334C17.9291 6.08043 15.7792 5.51673 14.1062 6.49446C12.4333 7.47219 11.8696 9.62209 12.8474 11.295C13.8251 12.9679 15.975 13.5316 17.6479 12.5539C19.3208 11.5762 19.8845 9.42626 18.9068 7.75334Z",
    fill: "url(#paint0_linear_119_282)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_119_282",
    x1: 12.6934,
    y1: 0,
    x2: 12.6934,
    y2: 20.2222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B426D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7419FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlettiMarker);
export default __webpack_public_path__ + "static/media/fletti-marker.70a346c49ad6618b78573a734ee05efc.svg";
export { ForwardRef as ReactComponent };